import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { TimerService } from 'src/app/services/timer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateTimerComponent } from './create-timer/create-timer.component';
import { MatDialog } from '@angular/material/dialog';

enum alerta_valor {
  '03' = 'Alerta en proceso',
  '02' = 'Alerta rechazada',
}

@Component({
  selector: 'app-timer-management',
  templateUrl: './timer-management.component.html',
  styleUrls: ['./timer-management.component.scss'],
})
export class TimerManagementComponent implements OnInit {
  alerta_valor = alerta_valor;
  displayedColumns: string[] = [
    'tipo_alerta',
    'units',
    'escala',
    'valor',
    'actions',
  ];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private timerService: TimerService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.timerService.toHeaderInfo.next({
      information: 'Configuración de temporizadores',
    });
    this.loadTimers();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  // Cargar los temporizadores desde el servicio
  loadTimers() {
    this.timerService.findAllTimer().subscribe({
      next: (timers) => {
        this.dataSource.data = timers;
        console.log('timers', timers);
      },
      error: (err) => {
        console.error('Error al cargar los temporizadores:', err);
        this.snackBar.open('Error al cargar los temporizadores', 'Cerrar', {
          duration: 3000,
        });
      },
    });
  }

  getNameUnit(units) {
    const unitNames = units.map((unit) => unit.name).join(', ');
    console.log('unitNames', unitNames);

    return unitNames;
  }

  capitalize(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // Editar un temporizador
  editTimer(timer: any) {
    this.dialog
      .open(CreateTimerComponent, {
        width: '700px',
        data: timer,
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        // Actualizar el elemento en el dataSource
        if (result) {
          const index = this.dataSource.data.findIndex(
            (t) => t._id === timer._id
          );
          if (index !== -1) {
            this.dataSource.data[index] = result; // Sustituir el elemento actualizado
            this.dataSource._updateChangeSubscription(); // Notificar a la tabla del cambio
          }
          this.snackBar.open(
            'Temporizador actualizado correctamente',
            'Cerrar',
            {
              duration: 3000,
            }
          );
        }
      });
  }

  // Eliminar un temporizador
  deleteTimer(timerId: string) {
    this.timerService.deleteTimer(timerId).subscribe({
      next: () => {
        // Eliminar el elemento del dataSource
        const index = this.dataSource.data.findIndex((t) => t._id === timerId);

        if (index !== -1) {
          this.dataSource.data.splice(index, 1); // Eliminar el elemento
          this.dataSource._updateChangeSubscription(); // Notificar a la tabla del cambio
        }
        this.snackBar.open('Temporizador eliminado correctamente', 'Cerrar', {
          duration: 3000,
        });
      },
      error: (err) => {
        console.error('Error al eliminar el temporizador:', err);
        this.snackBar.open('Error al eliminar el temporizador', 'Cerrar', {
          duration: 3000,
        });
      },
    });
  }

  createTimer() {
    this.dialog
      .open(CreateTimerComponent, {
        width: '700px',
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.dataSource.data.push(result);
          this.dataSource._updateChangeSubscription();
          this.snackBar.open('Temporizador creado correctamente', 'Cerrar', {
            duration: 3000,
          });
        }
      });
  }
}
